var w = Object.defineProperty;
var O = (d, e, s) => e in d ? w(d, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : d[e] = s;
var p = (d, e, s) => O(d, typeof e != "symbol" ? e + "" : e, s);
const m = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit" width="16" height="16" style="vertical-align: middle;"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></svg>', v = {
  position: "absolute",
  top: "-40px",
  left: "0",
  width: "100%",
  height: "calc(100% + 40px)",
  border: "2px dashed rgba(99, 102, 241, 0.2)",
  borderTop: "none",
  boxSizing: "border-box",
  pointerEvents: "auto",
  transition: "all 0.2s ease-in-out",
  background: "transparent",
  backgroundOnEnter: "rgba(255, 255, 255, 0.1)",
  backgroundOnLeave: "transparent"
}, x = {
  position: "absolute",
  background: "rgb(99, 102, 241)",
  backgroundOnEnter: "rgb(79, 82, 221)",
  backgroundOnLeave: "rgb(99, 102, 241)",
  top: "10px",
  left: "10px",
  zIndex: "1000",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "8px 12px",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  pointerEvents: "auto",
  opacity: "0",
  transition: "all 0.2s ease-in-out",
  fontSize: "13px",
  lineHeight: "1",
  whiteSpace: "nowrap",
  visibility: "hidden",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontWeight: "500"
};
let E = class {
  constructor(e, s, n) {
    p(this, "studioUrl");
    p(this, "inPreview", !1);
    p(this, "parent", null);
    p(this, "styleOptions");
    this.endpoint = e, this.styleOptions = s, n ? this.studioUrl = n : this.studioUrl = this.constructStudioUrl(this.endpoint), this.inPreview = window.self !== window.top, this.handleCustomDataAttributes();
  }
  handleCustomDataAttributes() {
    document.querySelectorAll(
      "[data-hygraph-entry-id]"
    ).forEach((s) => {
      const n = s.getAttribute("data-hygraph-entry-id");
      if (!n)
        return;
      const c = s.getAttribute("data-hygraph-field-api-id"), t = s.getAttribute("data-hygraph-field-locale");
      let l = `${this.studioUrl}/entry?endpoint=${this.endpoint}&entryId=${n}`;
      c && (l += `&fieldApiId=${c}`), t && (l += `&locale=${t}`), this.createOverlay(s, l);
    });
  }
  createOverlay(e, s) {
    var g, b;
    const n = document.createElement("div");
    n.className = "hygraph-overlay";
    const c = (g = this.styleOptions) != null && g.overlay ? {
      ...v,
      ...this.styleOptions.overlay
    } : v;
    Object.assign(n.style, c);
    const t = document.createElement("button"), l = e.getAttribute("data-hygraph-field-api-id"), h = document.createElement("div");
    h.style.cssText = `
      display: flex;
      align-items: center;
      height: 16px;
      width: 16px;
    `, h.innerHTML = m;
    const y = document.createElement("span");
    y.style.cssText = `
      display: inline-flex;
      align-items: center;
    `, y.innerHTML = l ? `Edit &nbsp;<b>${l}</b>&nbsp; in CMS` : "Edit in CMS", t.appendChild(h), t.appendChild(y);
    const f = (b = this.styleOptions) != null && b.tooltip ? {
      ...x,
      ...this.styleOptions.tooltip
    } : x;
    Object.assign(t.style, f), n.addEventListener("mouseenter", () => {
      var r, i, o, a;
      t.style.opacity = "1", t.style.visibility = "visible", t.style.transform = "translateY(2px)", n.style.border = ((i = (r = this.styleOptions) == null ? void 0 : r.overlay) == null ? void 0 : i.border) || "2px dashed rgba(99, 102, 241, 0.4)", n.style.background = ((a = (o = this.styleOptions) == null ? void 0 : o.overlay) == null ? void 0 : a.backgroundOnEnter) || "rgba(255, 255, 255, 0.1)";
    }), n.addEventListener("mouseleave", () => {
      var r, i, o, a;
      t.style.opacity = "0", t.style.visibility = "hidden", t.style.transform = "translateY(0)", n.style.border = ((i = (r = this.styleOptions) == null ? void 0 : r.overlay) == null ? void 0 : i.border) || "2px dashed rgba(99, 102, 241, 0.2)", n.style.background = ((a = (o = this.styleOptions) == null ? void 0 : o.overlay) == null ? void 0 : a.backgroundOnLeave) || "transparent";
    }), t.addEventListener("mouseenter", () => {
      var i, o;
      const r = ((o = (i = this.styleOptions) == null ? void 0 : i.tooltip) == null ? void 0 : o.backgroundOnEnter) || "rgb(79, 82, 221)";
      t.style.background = r, t.style.transform = "translateY(1px)", t.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.1)";
    }), t.addEventListener("mouseleave", () => {
      var i, o, a, u;
      const r = ((o = (i = this.styleOptions) == null ? void 0 : i.tooltip) == null ? void 0 : o.backgroundOnLeave) || "rgb(99, 102, 241)";
      t.style.background = r, t.style.transform = "translateY(0)", t.style.boxShadow = ((u = (a = this.styleOptions) == null ? void 0 : a.tooltip) == null ? void 0 : u.boxShadow) || "0 2px 4px rgba(0, 0, 0, 0.1)";
    }), t.onclick = () => {
      var r, i;
      if (this.inPreview) {
        const o = e.getAttribute("data-hygraph-entry-id");
        o && ((r = this.parent) == null ? void 0 : r.origin) === this.studioUrl && ((i = this.parent) != null && i.pathname.includes(`/entry/${o}`)) ? window.parent.postMessage(
          { action: "highlightField", fieldApiId: l },
          "*"
        ) : window.open(s, "_blank");
      } else
        window.open(s, "_blank");
    }, n.appendChild(t), e.style.position = "relative", e.appendChild(n);
  }
  setParent(e) {
    this.parent = e;
  }
  constructStudioUrl(e) {
    return `https://studio-${new URL(e).hostname.replace(".api", "").replace(".cdn", "")}`;
  }
};
export {
  E as H
};
